const getValueFromLocalStorage = (key: string): string => {
  let value: string | null;
  try {
    value = localStorage.getItem(key);
  } catch (error) {
    value = '';
  }
  return value as string;
};

const LANGUAGE_KEY = 'language';

export type SupportedLanguagesType = 'en' | 'fr';

class StorageService {
  getLanguage() {
    return getValueFromLocalStorage(LANGUAGE_KEY) as SupportedLanguagesType;
  }

  updateLanguage(language: string) {
    localStorage.setItem(LANGUAGE_KEY, language);
  }

  flush() {
    localStorage.removeItem(LANGUAGE_KEY);
  }
}

export default new StorageService();
